/**
 * iTRAXX Configuration
 * 
 * Hanterar miljö-baserade inställningar för development och production.
 * Använder environment variables när de finns tillgängliga.
 */

const config = {
    development: {
        API_URL: process.env.REACT_APP_API_URL || (typeof window !== 'undefined' ? `${window.location.origin}/api` : '/api'),
        WS_URL: process.env.REACT_APP_WS_URL || (typeof window !== 'undefined' ? `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}` : ''),
        TRACCAR_URL: process.env.REACT_APP_TRACCAR_URL || '',
        ENVIRONMENT: 'development'
    },
    production: {
        // Relative URLs - React och backend körs på samma server
        API_URL: process.env.REACT_APP_API_URL || '/api',
        WS_URL: process.env.REACT_APP_WS_URL || (typeof window !== 'undefined' ? `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}` : ''),
        TRACCAR_URL: process.env.REACT_APP_TRACCAR_URL || '/traccar',
        ENVIRONMENT: 'production'
    }
};

// Detektera miljö från NODE_ENV eller hostname
const getEnvironment = () => {
    // 1. Kolla NODE_ENV (sätts automatiskt av React Scripts)
    if (process.env.NODE_ENV === 'production') {
        return 'production';
    }
    
    // 2. Kolla hostname (fallback)
    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname;
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return 'development';
        }
    }
    
    // 3. Default till development för säkerhet
    return 'development';
};

const ENV = getEnvironment();
const currentConfig = config[ENV];

// Logga config i development (men inte känslig data)
if (ENV === 'development') {
    console.log('🔧 iTRAXX Config:', {
        environment: ENV,
        API_URL: currentConfig.API_URL,
    });
}

// Export individual values för convenience
export const API_URL = currentConfig.API_URL;
export const WS_URL = currentConfig.WS_URL;
export const TRACCAR_URL = currentConfig.TRACCAR_URL;
export const ENVIRONMENT = currentConfig.ENVIRONMENT;
export const IS_PRODUCTION = ENV === 'production';
export const IS_DEVELOPMENT = ENV === 'development';

// Export hela config object
export default currentConfig;
